import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Theme from '../ui/Theme';
import CollectionCard from './CollectionCard';
import CollectionChip from './CollectionChip';
import SearchBox from '../common/SearchBox';
import { getCollection, getCollectionList, showProgress } from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import useCollection from './hooks/useCollection';
toast.configure();
const customStyles = {
  content: {
    height: '580px',
    width: '954px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
const useStyles = makeStyles(() => ({
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '98px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '112px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginTop: '0px',
  },
  chipContainerText: {
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginTop: '0px',
    color: 'grey',
  },
  popupMainContainer: {
    marginTop: '43px',
  },
  chipsContainer: {
    width: '954px',
    height: '126px',
    marginTop: '22px',
    background: '#F9FAFB',
    borderRadius: '8px',
    padding: '16px',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  mainContainer: {
    width: '954px',
    height: '295px',
    marginTop: '22px',
    background: '#F2F4F7',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  footer: {
    marginTop: '26px',
  },
}));

const AddCollectionPopup = (props) => {
  const classes = useStyles();
  const { fetchJourneys } = useCollection();
  const totalJourneyList = useSelector((state) => state.GetJourneyList.journeylist);
  const details = useSelector((state) => state.getCollection.collection);
  const [selectedArr, setSelectedArr] = useState([]);
  const [filterListArray, setFilterListArray] = useState([]);
  const [filterArray, setFilterArray] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => fetchJourneys(), [fetchJourneys]);
  useEffect(() => {
    const ids = details?.journeys.map((journey) => journey.id);
    setSelectedArr(ids);
  }, [details]);
  useEffect(() => {
    setFilterListArray(totalJourneyList);
    setFilterArray(totalJourneyList);
  }, [totalJourneyList]);
  const submitJourneys = async () => {
    dispatch(showProgress(true));
    await service
      .post(apiEndpoints.COLLECTION_UPDATE_JOURNEY.replace('JOURNEY_ID', props.id), { journeyIds: selectedArr })
      .then(() => {
        props.close();
        const objArr = [];
        selectedArr.forEach((element) => {
          const obj = totalJourneyList?.filter((item) => item.id === element);
          objArr.push(obj[0]);
        });
        dispatch(getCollection('update_journey', objArr));
        const tempObj = { id: props.id, journeys: objArr };
        dispatch(getCollectionList('collectionJourneyCount', tempObj));
        notifySuccess('Saved Successfully');
        dispatch(showProgress(false));
      })
      .catch((error) => {
        props.close();
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const handleChipCloseFn = (id) => {
    const tempArr = selectedArr;
    const index = selectedArr.indexOf(id);
    if (index > -1) {
      tempArr.splice(index, 1);
    }
    setSelectedArr([...tempArr]);
  };
  const handleDataChange = (e) => {
    const tempArr = selectedArr;
    const index = selectedArr.indexOf(parseInt(e.target.id, 10));
    if (index > -1) {
      tempArr.splice(index, 1);
    } else if (index === -1) {
      tempArr.push(parseInt(e.target.id, 10));
    }
    setSelectedArr([...tempArr]);
  };
  const handleSearch = (e) => {
    const input = e.target.value;
    const filteredArray = input
      ? filterListArray.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
      : filterListArray;
    setFilterArray(filteredArray);
  };
  return (
    <Modal isOpen onRequestClose={props.close} style={customStyles}>
      <Grid container direction="row" alignItems="center">
        <Grid item xs={6}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              Edit Collection Journeys
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5}>
          <SearchBox handleChange={handleSearch} />
        </Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={props.close} />
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.chipsContainer}>
        {selectedArr?.map((id) => {
          const element = totalJourneyList?.filter((item) => item.id === id);
          if (!element) return null;
          return (
            <Grid item>
              <CollectionChip
                jId={id}
                title={element[0]?.title}
                handleChipClose={() => {
                  handleChipCloseFn(id);
                }}
              />
            </Grid>
          );
        })}
        {!selectedArr ||
          (selectedArr?.length === 0 && (
            <Typography className={classes.chipContainerText}>Added journey will show up here..</Typography>
          ))}
      </Grid>
      <Grid container className={classes.mainContainer}>
        <Grid item style={{ padding: '24px 0px 24px 0px' }}>
          <Grid container direction="row">
            {filterArray?.map((element) => (
              <Grid item>
                <CollectionCard journey={element} handleChange={handleDataChange} selectedArr={selectedArr} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end" alignItems="center" className={classes.footer}>
        <Button variant="contained" className={classes.popCancelBtn} onClick={props.close}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" className={classes.popSubmitBtn} onClick={submitJourneys}>
          Save
        </Button>
      </Grid>
      <ShowProgress />
    </Modal>
  );
};

export default AddCollectionPopup;
